/**
 * Format a Date using its LOCAL calendar date, not `.toISOString()`'s UTC
 * date -- the latter silently returns tomorrow's date for any local time
 * from 18:00-23:59 in a negative-UTC-offset zone (this app is deployed for
 * America/Tegucigalpa, UTC-6), which is the root cause of the "agenda days
 * shifted by one" production bug.
 */
export function dateToLocalYMD(date: Date): string {
  const y = date.getFullYear();
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  const d = date.getDate().toString().padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** JS Date#getDay() is Sunday=0; the backend's day_of_week is Monday=0. */
export function toBackendDayOfWeek(date: Date): number {
  return (date.getDay() + 6) % 7;
}
